module.exports = __webpack_public_path__ + "cfd270a8a06caae6799be6a014bdf7bd.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/img/sidebar-toggler.jpg
 ** module id = 384
 ** module chunks = 0
 **/